import React from 'react';
import { MdLocalOffer } from 'react-icons/md';

const OfferCard = () => {
  return (
    <div className="absolute top-20 right-4 bg-green-500 text-white rounded-full shadow-lg px-5 py-2 flex items-center cursor-pointer transition-transform transform hover:scale-105">
      <MdLocalOffer className="text-2xl mr-2" />
      <p className="text-sm font-semibold">Offers & Events</p>
    </div>
  );
};

export default OfferCard;
